import React from 'react';
import { Modal } from 'antd';
import {
  ExclamationCircleOutlined,
  CloseCircleFilled,
} from '@ant-design/icons';
import cn from 'classnames';
import { SuccessfulScreen } from 'components/Atoms';
import { UploadingIcon } from 'components/Atoms/Icon';

const { confirm, error, info } = Modal;

export const showModalError = ({
  title,
  content,
  icon,
  okText,
  okType,
  onOk,
  onCancel,
  centered = true,
}) => {
  error({
    title: title || '',
    icon: icon || <CloseCircleFilled style={{ color: '#FF5A5B' }} />,
    content: content || '',
    okText: okText || 'OK',
    okType: okType || 'primary',
    className: 'error-alert',
    okButtonProps: {
      style: {
        minWidth: '82px',
        height: '32px',
        borderRadius: '50px',
        borderColor: '#FFA39E',
        backgroundColor: '#FFF1F0',
        color: '#FF4D4F',
      },
    },
    centered,
    onOk(close) {
      onOk && onOk();
      close();
    },
    onCancel() {
      onCancel && onCancel();
    },
  });
};

export const showModalConfirm = ({
  title = '',
  content = '',
  icon,
  okText = 'Yes',
  okType = 'primary',
  cancelText,
  onOk = () => Promise.resolve(),
  onCancel = () => Promise.resolve(),
  loading,
  centered = false,
  ...rest
}) => {
  return confirm({
    title: title,
    icon: icon || <ExclamationCircleOutlined />,
    content: content,
    okText: okText,
    okType: okType,
    cancelText: cancelText || 'No',
    onOk,
    onCancel,
    centered,
    closable: true,
    ...rest,
  });
};

export const showModalConfirmStylePrimary = (props) => {
  const { btnWidth } = props;

  return showModalConfirm({
    ...props,
    icon: null,
    centered: true,
    className: cn('my-modal-confirm-primary-style', props.className),
    okButtonProps: {
      className: 'site-button btn-primary-custom h-45',
      style: {
        width: btnWidth || '175px',
      },
    },
    cancelButtonProps: {
      className: 'site-button btn-secondary-outline h-45',
      style: {
        width: btnWidth || '175px',
      },
    },
  });
};

export const showModalSuccessfulScreen = (props) => {
  const modal = info({
    icon: null,
    className: 'my-modal-successful-screen',
    centered: true,
    content: (
      <SuccessfulScreen
        {...props}
        onClickButtonPrimary={() => {
          props.onClickButtonPrimary && props.onClickButtonPrimary();
          modal.destroy();
        }}
      />
    ),
    okButtonProps: { style: { display: 'none' } },
  });
};

export const showLoadingModal = () => {
  const modal = info({
    icon: null,
    className: 'upload-modal-wrapper',
    wrapClassName: 'upload-modal-wrapper',
    centered: true,
    content: (
      <div className="t-center">
        <UploadingIcon />
        <div className="upload-text mt-30">
          Video upload is in progress and takes a few minutes...
        </div>
      </div>
    ),

    okButtonProps: { style: { display: 'none' } },
  });
  return modal;
};
